/**
 * Checks if the given input is a valid Map
 */
const isMap = (map: any) => map instanceof Map;
export default isMap;
